import { itemFinalCost } from './itemFinalCost';
import { getActiveFeePercentage } from './getActiveFeePercentage';
import { getLowestPriceItem } from './getLowestPriceItem';
import { PRIVATE_SALES } from '../constants';
// import { throwbacks } from '../constants/throwbacks';

/**
 * This function updates each item object in the option.items array
 * @param {object} active
 * @param {object} option
 * @param {number} cohort
 * @returns {void}
 */
export const updateEachItem = (active, option, cohort) => {
  // -------------- CA EVENT OR FOUNDERS Logic -------------- //
  const EVENT_DISCOUNT = 'CA EVENT - NEW'; // OR 'FOUNDERS - NEW'
  const isNewClient = active.discount === EVENT_DISCOUNT;
  const lowestPriceItem = isNewClient ? getLowestPriceItem(option, cohort) : {};
  // ------------------------------------------------//

  const activePrivateSale = PRIVATE_SALES[active.privateSale]; // PS250 or PS500
  // Private Sale is not applicable if
  // 1. The option includes a bundle area and the selected private sale is not PS100
  // 2. The option total original cost is less than the selected private sale amount
  // 3. The total original cost is less than $800 for PS500

  // ----- New Rule May 11th, 2026 - Private Sale is allowed on Bundles and Full Body
  // const rule1 = option.items.some(
  //   (item) => item.parentAreaId === 'bundles' && activePrivateSale !== 100, // PS100 is the only private sale applicable for bundles
  // );
  const rule2 = option.totalOriginalCost < activePrivateSale;
  const rule3 =
    activePrivateSale === PRIVATE_SALES['PS500'] &&
    option.totalOriginalCost < 800;

  // const isPrivateSaleRestricted = rule1 || rule2 || rule3;
  const isPrivateSaleRestricted = rule2 || rule3;
  option.privateSale = isPrivateSaleRestricted ? 0 : activePrivateSale;

  const itemPrivateSale = option.privateSale / option.items.length; // Private Sale portion of each item
  const fee = getActiveFeePercentage(active); // Get the active fee percentage

  option.items.forEach((item) => {
    const price = item.prices[`cohort_${cohort}`];
    item.monthlyPrice = Math.round(price / option.financePlan);

    item.finalCost = itemFinalCost(
      item,
      itemPrivateSale,
      cohort,
      lowestPriceItem, // For CA EVENT OR FOUNDERS Logic
    );
    // -------------  Throwback logic ------------------ //
    //  item.finalCost -= throwbacks[item.id] || 0;
    // --------------------------------------------------//
    item.fee = fee > 0 ? item.finalCost * fee : 0;
  });
};
